import React from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Button, Col, FormControl, FormGroup, Glyphicon, Row} from "react-bootstrap"
import {TableHeaderColumn} from "react-bootstrap-table"
import BaseGrid from "../BaseGrid"
import FormButtons from "../form/FormButtons"
import {createOptions, Date, Enums, Grid} from "../../utils"
import {IntakeTypeLabel} from "../../utils/enums";
import {formatIntakeDescription, formatParty} from "../../utils/format";
import IntakeForm, {createIntakeInitialValues} from "./IntakeForm";

class Intakes extends BaseGrid {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			itemModalOpen: false,
			intakeId: null,
			dog: null,
			action: null,
			actionModalOpen: null,
			actionItems: []
		};

		this.formatUser = this.formatUser.bind(this);
		this.formatAnimal = this.formatAnimal.bind(this);
		this.formatActions = this.formatActions.bind(this);

		this.handleItemModalClick = this.handleItemModalClick.bind(this);
		this.handleItemModalDismiss = this.handleItemModalDismiss.bind(this);

		this.handleActionSelect = this.handleActionSelect.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelectAll = this.handleRowSelectAll.bind(this);

		this.handleActionModalDismiss = this.handleActionModalDismiss.bind(this);
	}

	getDefaultFilter() {
		return {
			"dogId": null,
			"intakeTypes": [],
			"statuses": ["ACTIVE"],

			"search": "",
			"orderCol": "dogNumber",
			"orderDir": "a",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	componentWillMount() {
		this.props.onFetchEnums(['dogAll', 'breed']);
		super.componentWillMount();
	}

	handleRowSelect({intakeId}, isSelected) {
		const {actionItems} = this.state;
		if (isSelected) {
			this.setState({
				actionItems: [...actionItems, intakeId].sort()
			});
		} else {
			this.setState({actionItems: actionItems.filter(it => it !== intakeId)});
		}
		return false;
	}

	handleRowSelectAll(isSelected) {
		const {items} = this.props;
		if (!isSelected) {
			this.setState({actionItems: []})
		} else {
			const actionItems = [];
			for (let i = 0; i < items.length; i++) {
				actionItems.push(items[i].intakeId)
			}
			this.setState({actionItems: actionItems})
		}
	}

	handleActionSelect(action) {
		this.setState({action: action})
	}

	handleActionSubmit() {
		const {actionItems, action} = this.state;
		if (!actionItems || !actionItems.length || !action || !action.value) {
			return
		}

		this.setState({actionModalOpen: true})
	}

	handleActionModalDismiss() {
		this.setState({actionModalOpen: false})
	}

	renderActionModal() {
		// const {session} = this.props;
		const {actionModalOpen, actionItems} = this.state;
		if (!actionModalOpen) {
			return null
		}
		const {items} = this.props;
		const selected = [];
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				if (actionItems.indexOf(items[i].intakeId) >= 0) {
					selected.push(items[i])
				}
			}
		}
	}

	handleItemModalClick(intakeId) {
		const {filter: {dogId}} = this.state;
		if (!intakeId && dogId) {
			this.props.onLoadDog(dogId).then((json) => {
				this.setState({itemModalOpen: true, intakeId, dog: json.response.data})
			});
		} else {
			this.setState({itemModalOpen: true, intakeId, dog: null})
		}
	}

	handleItemModalDismiss() {
		this.setState({itemModalOpen: false, intakeId: null, dog: null})
	}

	renderItemModal() {
		const {session} = this.props;
		const {itemModalOpen, intakeId, filter: {dogId}, dog} = this.state;
		if (!itemModalOpen) {
			return null
		}

		const modal = {
			onHide: this.handleItemModalDismiss,
			onSuccess: (item) => {
				this.props.onFetchEnums(['dogAll']);
				this.handleInputChange({name: 'dogId', value: item.dogId}, true);
			}
		};

		return <IntakeForm intake={createIntakeInitialValues(intakeId, dogId, session, dog)} modal={modal}/>
	}

	formatDate(cell) {
		return Date.formatDate(cell);
	}

	formatType(cell) {
		return IntakeTypeLabel[cell];
	}

	formatUser(cell) {
		const {enums} = this.props;
		return Enums.getEnumTitle(enums, 'user', cell)
	}

	formatAnimal(cell) {
		const {enums} = this.props;
		return <Link to={{pathname: "/psi/" + cell}} className="btn">{Enums.getEnumTitle(enums, 'dogAll', cell)}</Link>
	}

	formatActions(cell) {
		return <span>
			<Button bsStyle={'link'} onClick={() => this.handleItemModalClick(cell)}><Glyphicon glyph="pencil"/></Button>
		</span>
	}

	formatRow(row) {
		return (row && row.status === 'DELETED' ? "alert-muted" : null)
	}

	getFilter() {
		const {enums} = this.props;
		const {filter} = this.state;

		const statuses = [
			{value: 'ACTIVE', label: 'Aktivní'},
			{value: 'DELETED', label: 'Ne'}
		];

		return [
			<Row key="1">
				<Col xs={3}>
					<FormGroup>
						<FormControl type="text" value={filter.search} name="search" placeholder="Jméno, číslo" onChange={this.handleInputChange}/>
					</FormGroup>
				</Col>
				<Col xs={2}>
					{Grid.renderSelect("dogId", 'Všechna zvířata', filter.dogId, Enums.createEnumItems(enums, 'dogAll', true), this.handleSelectChange, true)}
				</Col>
				<Col xs={4}>
					{Grid.renderSelect("intakeTypes", 'Všechny typy', filter.intakeTypes, createOptions(IntakeTypeLabel), this.handleSelectChange, false, true)}
				</Col>
				<Col xs={3}>
					<Row>
						<Col xs={6}>
							<FormButtons currentValue={filter.statuses} options={statuses} name="statuses" onInputChange={this.handleInputChange}/>
						</Col>
						{Grid.renderFilterButtons(this.onFilterReset, 6)}
					</Row>
				</Col>
			</Row>];
	}

	getCols() {
		return [
			<TableHeaderColumn key="intakeId" dataField="intakeId" width='5%' dataAlign="center" dataSort={true}>#</TableHeaderColumn>,
			<TableHeaderColumn key="intakeAt" dataField="intakeAt" width='8%' dataAlign="center" dataFormat={this.formatDate} dataSort={true}>Datum</TableHeaderColumn>,
			<TableHeaderColumn key="intakeType" dataField="intakeType" width='13%' dataAlign="center" dataFormat={this.formatType} dataSort={true}>Typ</TableHeaderColumn>,
			<TableHeaderColumn key="dogId" dataField="dogId" width='9%' dataAlign="center" dataFormat={this.formatAnimal} dataSort={true}>Zvíře</TableHeaderColumn>,
			<TableHeaderColumn key="dogNumber" dataField="dogNumber" width='6%' dataAlign="center" dataSort={true}>Ev. č.</TableHeaderColumn>,
			<TableHeaderColumn key="partyId" dataField="partyId" width='13%' dataAlign="center" dataFormat={(_, r) => formatParty(r, false)} dataSort={true}>Subjekt</TableHeaderColumn>,
			<TableHeaderColumn key="description" dataField="intakeId" width='30%' dataAlign="center" dataFormat={(_, r) => formatIntakeDescription(r, false)}>Popis</TableHeaderColumn>,
			<TableHeaderColumn key="intakeBy" dataField="intakeBy" width='10%' dataAlign="center" dataFormat={this.formatUser} dataSort={true}>Provedl</TableHeaderColumn>,
			<TableHeaderColumn key="actions" dataField="intakeId" width='6%' dataAlign="center" dataFormat={this.formatActions}>&nbsp;</TableHeaderColumn>
		]
	}

	render() {
		const {isFetchingItems, items, count, filter} = this.props;

		const actions = null;

		const actionCtx = {
			onActionSelect: this.handleActionSelect,
			onActionSubmit: this.handleActionSubmit,
			value: this.state.action,
			key: 'intakeId',
			selectRowProp: {
				mode: 'checkbox',
				clickToSelect: true,
				onSelect: this.handleRowSelect,
				onSelectAll: this.handleRowSelectAll,
				selected: this.state.actionItems,
				bgColor: function (row, isSelect) {
					if (isSelect) {
						return "#fcf8e3"
					}
					return null;
				},
				unselectable: []
			},
			actions: actions
		};

		return <div>
			<Button className={'grid-new-button'} bsStyle={'success'} onClick={() => this.handleItemModalClick(null)}><Glyphicon glyph="plus"/> Nový příjem</Button>
			{Grid.renderFull(isFetchingItems, items, count,
				Grid.getTableOptions(filter, this.onPageChange, this.onSortChange, this.onFilterChange, this.renderPaginationShowsTotal),
				this.getCols(),
				this.getFilter(),
				this.onFilterChange,
				actionCtx, this.formatRow)}
			{this.renderActionModal()}
			{this.renderItemModal()}
		</div>
	}
}

Intakes.propTypes = {
	...BaseGrid.propTypes,
	onLoadDog: PropTypes.func.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
};

export default withRouter(Intakes)



// WEBPACK FOOTER //
// ./src/components/intake/Intakes.js